import { CallState, SelectedStatus } from "@b2bportal/core-types";
import { createSelector } from "@reduxjs/toolkit";

import { htsSlice } from "./slice";

export const selectHtsSliceState = (
  state: Parameters<typeof htsSlice.selectSlice>[0]
) => {
  if (!(htsSlice.reducerPath in state)) {
    console.warn(
      `The slice reducer path "${htsSlice.reducerPath}" was not found in the state. Falling back to initial state.`
    );
    return htsSlice.getInitialState();
  }

  return htsSlice.selectSlice(state);
};

export const selectHtsAirCfarFetchRequest = createSelector(
  selectHtsSliceState,
  ({ fetchRequest }) => fetchRequest
);

export const selectHtsAirCfarFetchCallState = createSelector(
  selectHtsSliceState,
  ({ fetchCallState }) => fetchCallState
);

export const selectHtsAirCfarOffersState = createSelector(
  selectHtsSliceState,
  ({ offersState }) => offersState
);

export const selectSelectedHtsAirCfarOffer = createSelector(
  selectHtsSliceState,
  ({ selectedOffer }) => selectedOffer
);

export const selectCfarOfferWithSelectedStatus = createSelector(
  selectSelectedHtsAirCfarOffer,
  (selectedCfarOffer) =>
    selectedCfarOffer.status === SelectedStatus.SELECTED
      ? selectedCfarOffer
      : null
);

export const selectRoundTripOutboundSyntheticSelected = createSelector(
  selectHtsSliceState,
  (state) => state.roundTripOutboundSyntheticSelected ?? false
);

export const selectRoundTripOutboundSyntheticCoveragePercentage =
  createSelector(
    selectHtsSliceState,
    (state) => state.roundTripOutboundSyntheticCoveragePercentage
  );

export const selectShouldShowOnlySyntheticFares = createSelector(
  selectHtsSliceState,
  (state) => state.shouldShowOnlySyntheticFares ?? false
);

export const selectReturnSliceBatchCfarOffers = createSelector(
  selectHtsSliceState,
  (state) => state.returnSliceBatchCfarOffers
);

export const selectReturnSliceBatchCfarOffersData = createSelector(
  selectReturnSliceBatchCfarOffers,
  (batchOffers) => batchOffers?.data ?? {}
);

export const selectReturnSliceBatchCfarOffersState = createSelector(
  selectReturnSliceBatchCfarOffers,
  (batchOffers) => batchOffers?.state ?? CallState.NotCalled
);
